import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '#services';

/**
 * Protects routes by requiring an active Entra ID session.
 * Unauthenticated users are sent to /login to choose their IdP.
 * Authenticated users whose account is pending activation are redirected to /account-pending.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  const details = authService.userDetails();
  if (details !== null && details !== undefined && !details.isActive) {
    return router.createUrlTree(['/account-pending']);
  }

  return true;
};
